import request from "../servises/request";

export function getFormatData() {
  let p1 = new Promise((resolve, reject) => {
    request({
      url: `/user/age-range`,
      method: "get"
    }).then(r => resolve({ ageRange: r }));
  });
  let p2 = new Promise((resolve, reject) => {
    request({
      url: `/user/material-statuses`,
      method: "get"
    }).then(r => resolve({ materialStatuses: r }));
  });

  let p3 = new Promise((resolve, reject) => {
    request({
      url: `/user/statuses`,
      method: "get"
    }).then(r => resolve({ statuses: r }));
  });

  let p4 = new Promise((resolve, reject) => {
    request({
      url: `/user/gender`,
      method: "get"
    }).then(r => resolve({ gender: r }));
  });

  let p5 = new Promise((resolve, reject) => {
    request({
      url: `/user/roles`,
      method: "get"
    }).then(r => resolve({ roles: r }));
  });

  return Promise.all([p1, p2, p3, p4, p5])
  /*.then(
    value => {
      return new Promise((resolve, reject) =>{
        resolve(value)
      })

    },
    reason => {
      console.log(reason);
    }
  );*/
}
